export const RoutePaths = {
  PLAYLIST: "playlist",
  HOME: "/",
  PROFILE: "profile",
  PREVIEW_PLAYLIST: "preview",
  JOIN_CREW: "join-crew",
  MANAGE_CREWS: "manage-crews",
  LOGOUT: "logout",
  INFO_CONTACT: "info-contact",
  HELP: "help",
  CALLBACK: "callback",
  SCAN_QR_CODE: "scan-qr-code",
  LANDING_PAGE: "/overview.html",
  FORCE_LOGIN_QUERY_PARAM: "login",
  /** like FORCE_LOGIN_QUERY_PARAM, but opens the sign-up screen of Auth0 */
  FORCE_SIGNUP_QUERY_PARAM: "signup",

  SONGBOOKS: "songbooks",
  ITEMS: "items",

  // Testing & Demo Routes
  TEST_SETUP_AUTH: "testSetupAuth",
  STUB_LOGIN: "stub-login",
  DEMO_MULTI_SELECTABLE_LIST: "demo-multi-selectable-list",

  // Links
  toProfile: (id?: string) =>
    id
      ? `/${RoutePaths.PROFILE}/${encodeURIComponent(id)}`
      : `/${RoutePaths.PROFILE}`,
  toItem: (bucket: string, itemIdentifier: string) =>
    `/${bucket}/${RoutePaths.ITEMS}/${itemIdentifier}`,
  toItems: (bucket: string) => `/${bucket}/${RoutePaths.ITEMS}`,
  toNewItem: (bucket: string, id: string) =>
    `/${bucket}/${RoutePaths.ITEMS}/${id}`,
  toSongbooks: (bucket: string) => `/${bucket}/${RoutePaths.SONGBOOKS}`,
} as const;
